/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  DOCUMENT_STATUS_VIEW__HIDE,
  DOCUMENT_STATUS_VIEW__SHOW,
  DOCUMENT_STATUSES__FETCH,
  DOCUMENT_STATUS_VIEW__ERROR,
  DOCUMENT_STATUS__SAVE,
  DOCUMENT_STATUS_VIEW__LOADING,
  SET_CONSENTING
} from '../actions/actionTypes';

const documentStatusState = {
  documentId: null,
  documentName: null,
  error: null,
  isLoading: false,
  isVisible: 'hide',
  currentStatus: null,
  consenting: null
};

const documentStatusReducer = (state = documentStatusState, action) => {
  switch (action.type) {
    case DOCUMENT_STATUS_VIEW__HIDE:
      return Object.assign({}, state, documentStatusState);
    case DOCUMENT_STATUS_VIEW__SHOW:
      return Object.assign({}, state, {
        isVisible: 'show',
        documentId: action.payload.documentId,
        documentName: action.payload.documentName,
        currentStatus: action.payload.currentStatus,
        error: null
      });
    case DOCUMENT_STATUS_VIEW__ERROR:
      return Object.assign({}, state, { error: action.payload, isLoading: false });
    case DOCUMENT_STATUS_VIEW__LOADING:
      return Object.assign({}, state, { isLoading: true, error: null });
    case DOCUMENT_STATUSES__FETCH:
      return Object.assign({}, state, { documentStatuses: action.payload, isLoading: false, error: null });
    case DOCUMENT_STATUS__SAVE:
      return Object.assign({}, state, { isLoading: false, isVisible: 'hide', error: null });
    case SET_CONSENTING:
      return Object.assign({}, state, { consenting: action.consenting });
    default:
      return state;
  }
};

export default documentStatusReducer;
